import { cn } from "@fr8/frui";
import { Loader } from "lucide-react";
import { useOverlayVisible } from "~/hooks/useOverlayVisible";

const PageLoader = () => {
  // A dead-center overlay would land on top of (or behind) an open modal/drawer/
  // sheet, so it moves to a corner badge instead whenever one is visible —
  // still noticeable without competing with the overlay's own content.
  const overlayVisible = useOverlayVisible();

  return (
    <div
      className={cn(
        "fixed items-center animate-pulse flex gap-2 z-1000",
        overlayVisible ? " justify-center inset-0" : "bottom-16 right-3",
      )}
    >
      <Loader size={30} className="animate-spin text-blue-400" />
      <p className="font-medium text-sm">Loading...</p>
    </div>
  );
};

export default PageLoader;
